export default __webpack_public_path__ + "static/media/home.4b84471e.svg";